import { render, staticRenderFns } from "./OrganizationTree.vue?vue&type=template&id=0044611e&scoped=true&"
import script from "./OrganizationTree.vue?vue&type=script&lang=js&"
export * from "./OrganizationTree.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationTree.vue?vue&type=style&index=0&id=0044611e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0044611e",
  null
  
)

export default component.exports